export const baseUrl = "https://serverfinalproject3.fly.dev"
//export const baseUrl = "https://server-project-3.fly.dev" 
//export const baseUrl = "http://localhost:4000"
